import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { useGlobal } from '../contexts/GlobalContext';

const UserFollowedBySection = ({ onUpdate, boostInput = false, fieldName = 'user_id' }) => {
  const { defaultFarcasterUserId } = useGlobal();
  const [currentUserFollowedBy, setCurrentUserFollowedBy] = useState(defaultFarcasterUserId || '');
  const [boost, setBoost] = useState(1);

  const handleUserFollowedByAction = (actionType) => {
    if (!currentUserFollowedBy.trim()) return;
    
    const updateData = {
      action: actionType,
      filter: 'terms_lookup',
      lookup_index: 'farcaster-users',
      value: currentUserFollowedBy.trim(),
      field: fieldName,
      path: 'following_user_ids'
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    setCurrentUserFollowedBy(''); // Reset after adding
  };

  return (
    <Box>
      <TextField
        label="User ID"
        value={currentUserFollowedBy}
        onChange={(e) => setCurrentUserFollowedBy(e.target.value)}
        placeholder="Enter a single source user ID"
        helperText="e.g., 123"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUserFollowedByAction('include')}
          disabled={!currentUserFollowedBy.trim()}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleUserFollowedByAction('boost')}
            disabled={!currentUserFollowedBy.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleUserFollowedByAction('exclude')}
          disabled={!currentUserFollowedBy.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default UserFollowedBySection;
